<!--
 * @Author:
 * @Description: 接入配置管理
-->
<template>
  <el-card class="h-full">
    <el-row class="mb-10px flex">
      <selectStandardId @updateStandardId="updateStandardId" />
      <el-input
        class="!w-200px mx-10px"
        size="small"
        v-model="searchData.dataSourceName"
        placeholder="数据源名称"
        clearable
      ></el-input>
      <el-input
        class="!w-200px mr-10px"
        size="small"
        v-model="searchData.localIp"
        placeholder="数据源ip"
        clearable
      ></el-input>
      <el-select
        filterable
        class="!w-280px mr-10px"
        v-model="searchData.protocolType"
        size="small"
        placeholder="接口协议类型"
        clearable
      >
        <el-option
          v-for="item in protocolTypeOptions"
          :key="item.id"
          :label="item.sourceName"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        class="!w-280px mr-10px"
        filterable
        v-model="searchData.collectStatus"
        size="small"
        placeholder="操作状态"
        clearable
      >
        <el-option
          v-for="item in operationStatusOptions"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        filterable
        class="!w-280px mr-10px"
        v-model="searchData.monitorStatus"
        size="small"
        placeholder="真实状态"
        clearable
      >
        <el-option
          v-for="item in reallyStatesOptions"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-button size="small" type="primary" @click="getOpcDaList">搜索</el-button>
      <el-button size="small" @click="resetSearchTable">重置</el-button>
      <el-button size="small" type="primary" :disabled="!$hasAccess('create')" @click="addNewDriver"
        >新增</el-button
      >
    </el-row>
    <el-table
      :data="opcDaTableData"
      class="mt-20px"
      height="calc(100% - 104px)"
      row-key="dataSourceConfigId"
      ref="multipleTableRef"
      border
      stripe
    >
      <el-table-column type="index" width="50" :label="`${$t('serialNumber')}`">
        <template slot-scope="scope">
          <div>
            {{ scope.$index + 1 + (page.pageNo - 1) * page.pageSize }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="dataSourceName" label="数据源名称" show-overflow-tooltip />
      <el-table-column prop="localIp" label="数据源本地IP" show-overflow-tooltip />
      <el-table-column prop="protocolTypeName" label="接口协议类型" show-overflow-tooltip />
      <el-table-column prop="collectStatus" width="80px" label="操作状态">
        <template #default="scope">
          <el-switch
            :disabled="!$hasAccess('read')"
            :active-value="1"
            @change="changeState(scope.row)"
            :inactive-value="0"
            v-model="scope.row.collectStatus"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column width="80px" prop="collectStatusName" label="真实状态" show-overflow-tooltip>
        <!-- <template #default="scope">
          <span :class="[scope.row.monitorStatus === 0 ? 'font-green' : 'font-red']">
            {{ scope.row.monitorStatus === 0 ? '在线' : '离线' }}</span
          >
        </template> -->
      </el-table-column>
      <el-table-column prop="createdTime" label="创建时间" show-overflow-tooltip />
      <el-table-column prop="monitorTime" label="监控时间点" show-overflow-tooltip />
      <el-table-column label="操作" width="400px">
        <template #default="scope">
          <el-button size="mini" :disabled="!$hasAccess('read')" @click="viewPoint(scope.row)"
            >查看测点</el-button
          >
          <el-button size="mini" :disabled="!$hasAccess('update')" @click="edit(scope.row)"
            >编辑配置</el-button
          >
          <el-button size="mini" :disabled="!$hasAccess('delete')" @click="deleteConfig(scope.row)"
            >删除配置</el-button
          >
          <el-dropdown class="ml-10px">
            <el-button size="mini">
              更多<i class="iconfont icon-line-right text-12px"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="toRecoveryProgress(scope.row)">
                OPC HDA
              </el-dropdown-item>
              <el-dropdown-item @click.native="toMonitorRemindConfig(scope.row)">
                监控提醒配置
              </el-dropdown-item>
              <el-dropdown-item @click.native="toViewMonitorPoint(scope.row)">
                监控测点配置
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px text-right"
      background
      @size-change="searchList()"
      @current-change="getOpcDaList()"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :total="page.pageTotal"
      layout="sizes, total, prev, pager, next, jumper"
      :pager-count="5"
      :page-sizes="[15, 30, 50, 100]"
    >
    </el-pagination>
    <!-- 新增/编辑配置弹框 -->
    <configure-data-source-add-dialog
      v-if="showConfigDataSource"
      :standardId="standardId"
      :sourceType.sync="sourceType"
      :showConfigDatavisible="showConfigDatavisible"
      :protocolTypeOptions="protocolTypeOptions"
      :editTypeProp="editTypeProp"
      :currentData="currentData"
      @closeDataOriginDialog="closeDataOriginDialog"
    ></configure-data-source-add-dialog>
    <!-- 监控提醒配置弹框 -->
    <monitorPointRemindConfigDialog
      v-if="MonitorPointRemindConfigVisible"
      :visible="MonitorPointRemindConfigVisible"
      :rowData="rowData"
      @closeMonitorPointRemindConfigDialog="closeMonitorPointRemindConfigDialog"
    />
  </el-card>
</template>

<script>
import configManagementService from '@/services/configManagementService'
import selectStandardId from '../../components/selectStandardId'
import monitorPointRemindConfigDialog from './components/monitorPointRemindConfigDialog'

const configureDataSourceAddDialog = () => {
  return import('./components/configureDataSourceAddDialog')
}
export default {
  name: 'config-management',
  components: { selectStandardId, configureDataSourceAddDialog, monitorPointRemindConfigDialog },
  data() {
    return {
      standardId: localStorage.getItem('standardId'),
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      // 真实状态下拉列表
      reallyStatesOptions: [
        {
          id: 1,
          name: '在线',
        },
        {
          id: 0,
          name: '离线',
        },
      ],
      // 操作状态下拉列表
      operationStatusOptions: [
        {
          id: 1,
          name: '启动',
        },
        {
          id: 0,
          name: '停止',
        },
      ],
      interfaceType: [
        { id: 1, name: 'opc-da' },
        { id: 2, name: 'opc-plc' },
        { id: 3, name: 'opc-ua' },
        { id: 8, name: 'modbus' },
        { id: 9, name: 'iec104' },
        { id: 10, name: 'pidb' },
      ],
      dataSourceSearchCriteria: {
        dataSourceName: '',
        pageNo: 1,
        pageSize: 999,
      },
      opcDaTableData: [],
      protocolTypeOptions: [],
      showConfigDataSource: false,
      showConfigDatavisible: false,
      editTypeProp: 'edit',
      sourceType: 1,
      opcConfig: false,
      opcConfigVisible: false,
      currentData: {},
      searchData: {
        dataSourceName: '',
        localIp: '',
        protocolType: '',
        collectStatus: '',
        monitorStatus: '',
      },
      MonitorPointRemindConfigVisible: false,
      rowData: {},
    }
  },
  computed: {},
  created() {
    this.getOpcDaList()
    this.getProtocolType()
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
      this.getOpcDaList()
    },
    remoteGetProtocolType() {},
    // 页数改变
    searchList() {
      this.page.pageNo = 1
      this.getOpcDaList()
    },
    // 重置搜索表格
    resetSearchTable() {
      this.searchData = this.$options.data().searchData
      this.page = this.$options.data().page
      this.getOpcDaList()
    },
    // 修改状态
    async changeState(row) {
      const res = await configManagementService.updateCollectStatus({
        collectStatus: row.collectStatus,
        ids: [row.id],
      })
      if (res && res.code === 0) {
        this.$message.success('修改成功！')
        this.getOpcDaList()
      }
    },
    closeDataOriginDialog() {
      this.showConfigDataSource = false
      this.showConfigDatavisible = false
      this.resetSearchTable()
    },
    // 新增驱动
    addNewDriver() {
      this.showConfigDataSource = true
      this.showConfigDatavisible = true
      this.editTypeProp = 'create'
    },
    viewPoint(row) {
      this.$router.push({ name: 'data-view', params: { id: row.id } })
    },
    // 编辑驱动
    edit(data) {
      this.editTypeProp = 'edit'
      this.showConfigDataSource = true
      this.showConfigDatavisible = true
      this.currentData = data
    },
    toRecoveryProgress(data) {
      this.$router.push({ name: 'opc-hda', params: { data } })
    },
    // 获取接口协议类型
    async getProtocolType() {
      const res = await configManagementService.getProtocolType()
      if (res && res.code === 0) {
        this.protocolTypeOptions = res.data.map((item) => {
          return {
            id: item.id,
            sourceName: item.name,
          }
        })
      }
    },
    // 获取接入配置列表数据
    async getOpcDaList() {
      const params = {
        standardId: this.standardId,
        maxResultCount: this.page.pageSize,
        skipCount: this.page.pageSize * (this.page.pageNo - 1),
        ...this.searchData,
      }
      const res = await configManagementService.getCollectDataSourceConfigList(params)
      if (res && res.code === 0) {
        this.opcDaTableData = res.data
        this.page.pageTotal = res.totalCount
      }
    },
    // 删除配置
    async deleteConfig(data) {
      this.$confirm('是否确认删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await configManagementService.batchDeleteConfig([data.id])
        if (res && res.code === 0) {
          this.$message.success('删除成功！')
          this.resetSearchTable()
        }
      })
    },
    // 打开监控提醒配置弹框
    async toMonitorRemindConfig(row) {
      this.MonitorPointRemindConfigVisible = true
      this.rowData = row
    },
    // 关闭监控提醒配置弹框
    closeMonitorPointRemindConfigDialog() {
      this.MonitorPointRemindConfigVisible = false
    },
    // 跳转监控测点配置
    async toViewMonitorPoint(row) {
      this.$router.push({ name: 'view-monitorPoint', query: { id: row.id } })
    },
  },
}
</script>

<style lang="scss" scoped>

::v-deep .el-card__body {
  height: 100% !important;
}

</style>
